import { CancelTokenSource } from 'axios';
import axios from 'services/http';
import { UpsertMisantoImportDto } from 'ts-types/api.types';
import { number } from 'prop-types';

const {REACT_APP_API_BASE_URL: baseUrl} = process.env;
const apiUri = `${baseUrl}/api/misanto-import`;


export const createMisatnoImport = (values: Partial<UpsertMisantoImportDto>,
                                    source: CancelTokenSource) => {

  let bodyFormData = new FormData();
  Object.keys(values).forEach((key) => {
    let value = values[key as keyof UpsertMisantoImportDto];

    if (value) {
      if (typeof value === "number") {
        value = value.toString();
      }
      bodyFormData.append(key, value);
    }

  });

  return axios
      .post(`${apiUri}`, bodyFormData, {cancelToken: source.token});
};
